import styled from 'styled-components';
import hamburgerIcon from './assets/Hamburger_icon.png';
import resumeIcon from './assets/resume_icon.png';
import { memo, useEffect, useState } from 'react';
import { clamp } from 'three/src/math/MathUtils.js';
import { getHostDirectory } from '@tools/getHostDirectory';

const S = {
  Container: memo(styled.div`
    position: relative;
    width: 100%;
    height: 100%;
  `),

  DownloadWindow: styled.div`
    position: absolute;
    top: 8%;
    left: 20%;
    transform: translateX(-50%);
    height: 7.5rem;
    width: 25rem;
    font-family: 'Dogica', sans-serif;
    font-size: 0.7rem;
    word-spacing: -0.5ch;
  `,

  WindowContent: styled.div`
    position: relative;
    color: #000;
    width: 100%;
    height: 100%;
    background: #c0c7c8;
    border: 0.15rem solid rgb(255, 255, 255);
    border-color: #fff #000 #000 #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  TopBar: memo(styled.div`
    position: absolute;
    top: calc(-2rem + 0.5rem);
    width: 100%;
    padding: 0.2rem 0rem 0.2rem 0.7rem;
    background-color: #0000a8;
    border: 0.15rem solid rgb(255, 255, 255);
    border-color: #fff #000 #000 #fff;
  `),
  CloseButton: styled.div`
    border: 0.13rem solid rgb(255, 255, 255);
    border-color: #fff #000 #000 #fff;
    margin-top: 0.8rem;
    padding: 0.3rem 1rem;
    cursor: pointer;
    &:active {
      border-color: #000 #fff #fff #000;
    }
  `,
  ButtonsContainer: styled.div`
    position: absolute;
    top: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  `,
};

const BtnContent = memo(styled.div`
  cursor: pointer;
`);

const BtnIcon = memo(styled.div<{ url: string }>`
  margin: auto;
  width: 3.5rem;
  height: 3.5rem;
  background-image: url(${({ url }) => url});
  background-size: cover;
  margin-bottom: 0.1rem;
`);

const MenuText = memo(styled.div`
  text-align: center;
  font-family: 'Dogica', sans-serif;
  font-size: 0.7em;
  width: 6rem;
  word-wrap: break-word;
`);

const ProgressBarWrapper = styled.div`
  width: 85%;
  margin-top: 0.4rem;
  height: 1.5rem;
  background-color: #fff;
  border: 0.13rem solid rgb(255, 255, 255);
  border-color: #000 #fff #fff #000;
  overflow: hidden;
  position: relative;
`;

const ProgressBarFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => Math.max(0, Math.min(100, progress))}%;
  background: #0000a8;
`;

const ProgressBarText = styled.div<{ progress: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.8rem;
  background: linear-gradient(to right, white ${({ progress }) => progress}%, black 0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

const MenuButton = ({ downloadProgress, onClick }: { downloadProgress: number; onClick: () => void }) => {
  const [showDownloadWindow, setShowDownloadWindow] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (downloadProgress < 100) setShowDownloadWindow(true);
    if (downloadProgress === 100) setShowButton(true);
  }, []);

  useEffect(() => {
    if (downloadProgress === 100) {
      setShowButton(true);
    }
  }, [downloadProgress]);

  const handleClose = () => {
    if (downloadProgress < 100) console.log('HM UM NAN❌');
    else setShowDownloadWindow(false);
  };

  const onClickResume = () => {
    window.open(`${getHostDirectory()}src/resume/`, '_blank');
  };

  return (
    <S.Container>
      {showButton && (
        <S.ButtonsContainer>
          <BtnContent onClick={onClick}>
            <BtnIcon url={hamburgerIcon} />
            <MenuText>Menu.exe</MenuText>
          </BtnContent>
          <BtnContent onClick={onClickResume}>
            <BtnIcon url={resumeIcon} />
            <MenuText>Resume.html</MenuText>
          </BtnContent>
        </S.ButtonsContainer>
      )}

      {showDownloadWindow && (
        <S.DownloadWindow>
          <S.TopBar>Menu Setup&nbsp;Wizard</S.TopBar>
          <S.WindowContent>
            <h5></h5>
            <div>{downloadProgress === 100 ? 'Done!' : 'Installing...'}</div>
            <ProgressBarWrapper>
              <ProgressBarFill progress={downloadProgress} />
              <ProgressBarText progress={(12 - (56 - clamp(downloadProgress, 44, 56))) / 0.12}>
                {downloadProgress}%
              </ProgressBarText>
            </ProgressBarWrapper>
            <S.CloseButton onClick={handleClose}>{showButton ? 'Close' : 'Cancel'}</S.CloseButton>
          </S.WindowContent>
        </S.DownloadWindow>
      )}
    </S.Container>
  );
};

export default memo(MenuButton);
